export enum Role {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  OPERATOR = 'OPERATOR',
  INVESTIGATOR = 'INVESTIGATOR',
  REVIEWER = 'REVIEWER',
  ASSET_PROVIDER = 'ASSET_PROVIDER',
  EDR = 'EDR',
}

// Returns true if at least one role in userRoles matches a role in allowedRoles
export const hasMatchingAllowedRole = (userRoles: Role[] | undefined, allowedRoles: Role[]): boolean => {
  if (!userRoles) return false;

  return userRoles.some((role) => allowedRoles.includes(role));
};
